import Image from 'semantic-ui-react/dist/es/elements/Image';
import './Image.css';

export default Image;
